import {Injectable} from '@angular/core';
import {HttpService} from '@shared/service/http.service';
import {Observable, throwError} from 'rxjs';
import {ApiResponse} from '@shared/model';
import {catchError, map} from 'rxjs/operators';
import {HttpClient} from '@angular/common/http';
import {environment} from "../../../environments/environment";

@Injectable({
  providedIn: 'root'
})
export class ApiService {
  baseUrl = `${environment.apiUrl}`;

  constructor(public http: HttpService, public httpClient: HttpClient) {
  }

  get(partUrl: string): Observable<ApiResponse> {
    return this.http.get(`${this.baseUrl}${partUrl}`).pipe(map((response: any) => response as ApiResponse))
  }

  post(partUrl: string, payload: any, showToaster = false): Observable<ApiResponse> {
    return this.http.post(`${this.baseUrl}${partUrl}`, payload, showToaster).pipe(map((response: any) => response as ApiResponse))
  }

  put(partUrl: string, payload: any, showToaster = false): Observable<ApiResponse> {
    return this.http.put(`${this.baseUrl}${partUrl}`, payload, showToaster).pipe(map((response: any) => response as ApiResponse))
  }

  patch(partUrl: string, payload: any, showToaster = false): Observable<ApiResponse> {
    return this.http.patch(`${this.baseUrl}${partUrl}`, payload, showToaster).pipe(map((response: any) => response as ApiResponse))
  }

  delete(partUrl: string, showToaster = false): Observable<ApiResponse> {
    return this.http.delete(`${this.baseUrl}${partUrl}`, showToaster).pipe(map((response: any) => response as ApiResponse))
  }

  sendFile(partUrl: string, file: File): Observable<ApiResponse> {
    const formData: FormData = new FormData();
    formData.append('file', file);

    return this.httpClient
      .post<ApiResponse>(`${this.baseUrl}${partUrl}`, formData)
      .pipe(
        map((response) => {
          if (response) {
            return response; // Ensure the response matches ApiResponse
          }
          throw new Error('Unexpected response format');
        }),
        catchError((error) => {
          console.error('Error uploading file:', error);
          return throwError(() => error); // Propagate the error
        })
      );
  }
}
